import { useTranslation } from "react-i18next";
import ClockHand from "@components/ui/animations/Clock";
import LiveClock from "./LiveClock";

const DietPlanOverviewHeader = ({
  variant,
  showHeader,
  showClock,
  selectedDay,
  getMealTimeText,
  getPunchLine,
}) => {
  const { t } = useTranslation();

  if (variant === "dashboard") {
    return (
      <div className="flex items-center justify-between mb-4">
        <p className="text-[16px] font-[Lato]">
          <strong>{t(`days.${selectedDay.toLowerCase()}`)}'s</strong>{" "}
          {t("dashboard.mealPlanOverview")}
        </p>
      </div>
    );
  }

  if (!showHeader) return null;

  return (
    <div
      className="bg-white flex items-start justify-between py-[25px] px-[20px] rounded-md"
      style={{
        background: "linear-gradient(150deg, #0771EF 12.89%, #15AAFC 85.22%)",
      }}
    >
      <div className="flex flex-col gap-[5px] w-full">
        <div className="flex flex-col md:flex-row lg:flex-col xl:flex-row justify-between">
          <h1 className="text-[16px] lg:text-[14] xl:text-[16px] font-[700] font-[Lato] flex items-center gap-2 text-white">
            {showClock && <ClockHand className="w-7 h-7" />}
            {showClock && <LiveClock />}
            &nbsp;
            {getMealTimeText()}
          </h1>
          <div className="w-[fit-content] my-2 xl:my-0 px-[10px] lg:px-[10px] xl:px-[20px] text-[14px] md:text-[18px] text-[#0575E6] font-[Lato] font-[600] bg-white rounded-full flex items-center">
            {t(`days.${selectedDay.toLowerCase()}`)}
          </div>
        </div>

        <h1 className="text-[14px] xl:text-[16px] font-[400] font-[Lato] text-white">
          {t("dietPlanDashboard.mealListing.completeHeading")}
        </h1>

        <span className="inline-flex items-center rounded-full text-[14px] font-[Lato] font-[400] text-white">
          {getPunchLine()}
        </span>
      </div>
    </div>
  );
};

export default DietPlanOverviewHeader;
